import React from "react";
import Archive from "../../components/Archive/Archive";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Footer from "../../components/Footer/Footer";

const ArchivePage = () => {
  return (
    <>
      <Navbar />
      <Archive />
      <Footer />
    </>
  );
};
export default ArchivePage;
